import { useTranslations } from "@/lib/useTranslations";

interface LibraryResultsFreezeControlProps {
  isFrozen: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function LibraryResultsFreezeControl({
  isFrozen,
  onToggle,
  disabled = false,
}: LibraryResultsFreezeControlProps) {
  const t = useTranslations("common.library");

  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={isFrozen}
      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-1.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        isFrozen
          ? "border-amber-200 bg-amber-100 text-zinc-900"
          : "border-black/10 bg-white text-neutral-700 hover:bg-zinc-50"
      }`}
    >
      {isFrozen ? t("unfreezeResults") : t("freezeResults")}
    </button>
  );
}
